import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('962_games_matchmaker_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (email, password) => {
    // Simple mock authentication
    const mockUser = {
      id: 'user_' + Date.now(),
      email,
      role: email.includes('admin') ? 'Admin' : 'Developer',
      isAdmin: email.includes('admin')
    };

    setUser(mockUser);
    localStorage.setItem('962_games_matchmaker_user', JSON.stringify(mockUser));
    return Promise.resolve(mockUser);
  };

  const signup = (email, password) => {
    return login(email, password);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('962_games_matchmaker_user');
  };

  const value = {
    user,
    login,
    signup,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};